import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e2a44b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-row w-full" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "max-w-[80%] items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, idx) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "flex flex-col w-full mt-2",
      key: idx
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-row items-center space-x-2 w-full", [
          _ctx.messageIsFromAgent && 'justify-start',
          _ctx.messageIsFromClient && 'justify-end',
        ]])
        }, [
          _createElementVNode("span", {
            class: _normalizeClass([
            _ctx.messageIsFromAgent && `${_ctx.inboundStyleClass}`,
            _ctx.messageIsFromAgent &&
              _ctx.isFromPreviousConversation &&
              'bg-gray-100 text-gray-500',
            _ctx.messageIsFromAgent && !_ctx.isFromPreviousConversation && 'bg-gray-200',
            _ctx.messageIsFromClient && `${_ctx.outboundStyleClass}`,
            _ctx.messageIsFromClient &&
              (_ctx.isFromPreviousConversation || _ctx.isMessagePending) &&
              'opacity-60 pending',
            _ctx.messageIsFromClient &&
              !_ctx.isFromPreviousConversation &&
              !_ctx.isMessagePending &&
              '',
            'px-3 py-1.5 rounded-full whitespace-pre-line break-words transition-colors max-w-[80%] text-xs underline-offset-4 underline',
          ])
          }, [
            _createElementVNode("a", {
              href: file.url,
              target: "_blank"
            }, _toDisplayString(file.fileName), 9, _hoisted_2)
          ], 2)
        ], 2)
      ]),
      (_ctx.hasBottomSlot)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "bottom", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}